const links = {
  oneLink: 'https://udsite.onelink.me/AFzn/GlobalSite',
  inOneLink: 'https://india1.onelink.me/Ky0I/Officialwebsite',
  apkLink: 'https://interdict-apk.s3.ap-southeast-1.amazonaws.com/U-Dictionary_5.0.0.apk',
  huaweiLink: 'https://appgallery.huawei.com/#/app/C100504317',
}

export default links
